import { Box, Typography, makeStyles } from "@material-ui/core";
import * as React from "react";

import theme from "@/theme";

import { CustomButton } from "../Button";
import { StyledModal } from "../StyledModal";

const useStyles = makeStyles(() => ({
  messageContent: {
    padding: "24px 24px 0 24px",
  },
  buttonContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    gap: theme.spacing(1),
    marginTop: theme.spacing(2),
    borderTop: `1px solid ${theme.palette.semantic["border/default"]}`,
    padding: theme.spacing(2, 1),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(2, 1),
    },
  },
  description: {
    textAlign: "center",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  link: {
    textDecoration: "none",
    cursor: "pointer",
    textAlign: "center",
    padding: theme.spacing(1),
    "&:hover": {
      borderBottom: "none",
    },
  },
  title: {
    color: theme.palette.error.main,
    fontWeight: 700,
  },
}));

interface LeadCheckModalProps {
  onClose: () => void;
  onAccept: () => void;
  description?: string;
  primaryButtonLabel?: string;
}

export const LeadCheckModal: React.FC<LeadCheckModalProps> = ({ onClose, onAccept, description, primaryButtonLabel }) => {
  const classes = useStyles();
  const message =
    description ??
    "ZOOMによるライフプランコンサルティングには、ご家族構成や、現在の収入・支出・保有されている資産（株、NISA、iDeCo、生命保険 等）の情報をご提供いただきます。";
  const primaryLabel = primaryButtonLabel ?? "ZOOM面談を希望する";

  return (
    <StyledModal onClickOutside={onClose}>
      <Box className={classes.messageContent}>
        <Box textAlign="center" mb={2}>
          <Typography variant="h3" className={classes.title}>
            ご注意
          </Typography>
        </Box>
        <Typography className={classes.description}>{message}</Typography>
      </Box>
      <Box className={classes.buttonContainer}>
        <CustomButton customVariant="filledOrangeForMsins" onClick={onAccept}>
          {primaryLabel}
        </CustomButton>
        <Typography variant="button" color="primary" className={classes.link} onClick={onClose}>
          キャンセル
        </Typography>
      </Box>
    </StyledModal>
  );
};
